import { useState, useEffect } from 'react';

export function useLoginAnimation() {
  const [showFullLogo, setShowFullLogo] = useState(false);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowFullLogo(true), 3700);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setShowForm(true), 4700);
    return () => clearTimeout(t);
  }, []);

  return { showFullLogo, showForm };
}
